module.exports = __webpack_public_path__ + "media/images/new/icons/home-active-5fbd292154c8319e86a3578b0432a200.png";